import type { Signal } from '@angular/core';
import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';

import { ManholeAssetService } from '#/app/shared/services/api/manhole-asset.service';

import { resolveResourceAccessGuardResult } from './resource-access-guard';

/**
 * Guard that verifies a manhole asset exists and belongs to the tenant in the route.
 * Prevents route matching if the asset doesn't exist or belongs to a different tenant,
 * allowing fallback routes to handle 404 display.
 */
export const manholeAssetAccessCanMatchGuard: CanMatchFn = (
  _routes,
  _segments,
  _currentSnapshot,
) => {
  const manholeAssetService = inject(ManholeAssetService);
  const assetIdParam = _currentSnapshot?.paramMap.get('assetId') ?? '';

  return resolveResourceAccessGuardResult(assetIdParam, (assetIdSignal) =>
    manholeAssetService.manholeAssetResource(assetIdSignal as Signal<string>),
  );
};
